import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from '@material-ui/core';
import { Breadcrumb, BackdropCircular } from 'components';
import { getStoreEmailsApi } from 'api';
import SendingEmail from './SendingEmail';


const StoreEmails = () => {
  const dispatch = useDispatch();
  const { storeEmails, loadingStoreEmails } = useSelector((state: IReduxState) => state.store_emails);
  const [primaryEmailField, setPrimaryEmailField] = useState(storeEmails.primaryEmail);

  useEffect(() => {
    getStoreEmailsApi({ dispatch });
  }, []);

  useEffect(() => {
    setPrimaryEmailField(storeEmails.primaryEmail);
  }, [storeEmails]);

  return (
    <div className="scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Go Live Requirements', path: '/settings#go_live_requirements' },
            { name: 'Store Emails' }
          ]}
        />
      </div>
      <div className="m-10">
        <div className="mb-10 text-dark-gray">
          <h3>Store Emails</h3>
          <h5>Configure your Store&apos;s Primary Email</h5>
        </div>
        <Card>
          <SendingEmail
            primaryEmailField={primaryEmailField}
            setPrimaryEmailField={setPrimaryEmailField}
          />
        </Card>
      </div>
      <BackdropCircular loading={loadingStoreEmails} />
    </div>
  );
};

export default StoreEmails;
